import { Box, Checkbox, FormControlLabel, Input, Tooltip } from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createPortal } from "react-dom";
import { ReactComponent as DeleteSubTaskIcon } from "../../assets/images/deleteSubTaskIcon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendarIcon.svg";
import { ReactComponent as AddProfileWithCircle } from "../../assets/images/assignedToBlue.svg";
import { ReactComponent as CircleDelete } from "../../assets/images/icons/CircleDelete.svg";
import { ReactComponent as CircleEdit } from "../../assets/images/icons/CircleEdit.svg";
import { ReactComponent as DateLight } from "../../assets/images/icons/DateLight.svg";
import { boolean } from "yup";
import { getColorForName, getInitials } from "../../utils/utilityFunctions/stringUtility";
import { getDDMonthYYYY } from "../../utils/utilityFunctions/dateConvert";
import { color } from "framer-motion";
import FloatingList from "../UniversalComponents/FloatingElement";
import moment from "moment";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import { ReactComponent as ProfileIcon } from "../../assets/images/icons/profileIconTie.svg";
import CompletionCheckbox from "../UniversalComponents/CompletionCheckbox";
import { ReactComponent as UserIconInputBox } from "../../assets/images/icons/UserIconInputBox.svg";
import SelectComponent from "../UniversalComponents/SelectComponent";
import BasicSelect from "./BasicSelect";
import { Label } from "recharts";

export const SubTaskDrawer = ({
  handleDeleteSubtask,
  customerTaskCategory,
  startDate,
  endDate,
  personTableData,
  handleSubTaskPerson,
  handleCheck,
  searchTerm,
  subTaskContainerRef,
  formData,
  // handleSubtaskChange,
  handleSubtaskCheckboxChange,
  isFormDisabled,
  isEditTask,
  handleMouseEnter,
  handleMouseLeave,
  isSearchBarOpen,
  setIsSearchBarOpen,
  dropdownCoord,
  taskassignedtoref,
  subTaskSelected,
  setSubtaskSelected,
  fetchPersonData,
  subTaskForm,
  setSubTaskForm,
  initialSubTaskForm,
  addSubtask,
  addChecklist,
  subDrawer,
  open,
  setFormData,
  onClose,
}) => {
  const [openAssignedTo, setOpenAssignedTo] = useState(false);
  const [subTaskPersonSearch, setSubtaskPersonSearch] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [editingSubTaskId, setEditingSubTaskId] = useState(null);
  const datePickerRef = useRef(null);

  // console.log(subTaskForm, "vinaySubTaskForm subTaskDrawer");

  const myUserData = JSON.parse(localStorage.getItem("myUserData"));
  // console.log(myUserData.name, "myUserDatavinay");
  const handleSubtaskChange = (index, e) => {
    const { name, value, checked } = e.target;
    // console.log(e.target, "helllotarget");

    if (name === "assigned_to") {
      let newAssignedTo = [];
      const isAlreadyAssigned = subTaskForm?.assigned_to?.some((person) => person.id === value.id);
      if (isAlreadyAssigned) {
        newAssignedTo = [];
      } else {
        newAssignedTo = [value];
      }

      setSubTaskForm((prevForm) => ({ ...prevForm, [name]: newAssignedTo }));
    } else if (name === "show_on_calendar") {
      setSubTaskForm((prevForm) => ({ ...prevForm, [name]: checked }));
    } else if (name === "status") {
      const selectedStatus = customerTaskCategory?.data?.status.find((status) => status.value === value);

      setSubTaskForm((prevForm) => ({
        ...prevForm,
        status: value,
        status_color_code: selectedStatus?.colour_code || "",
      }));
    } else {
      setSubTaskForm((prevForm) => ({ ...prevForm, [name]: value }));
    }
    // console.log(subTaskForm, "hellosubtask");
  };

  const handleNewSubtaskCheckboxChange = (subtask, checked, index) => {
    setSubtaskSelected((prevState) => ({ ...prevState, [index]: checked }));
  };

  const handleDeleteSubTasks = (index) => {
    handleDeleteSubtask(
      Object.keys(subTaskSelected)?.length
        ? Object.keys(subTaskSelected).filter((key) => subTaskSelected[key])
        : [String(index)]
    );
    setSubtaskSelected({});
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleChangeSearch = (event) => {
    setSubtaskPersonSearch(event?.target?.value);
  };

  const handleEditSubTask = (value) => {
    // console.log(value, "hellovalue");
    setEditingSubTaskId(value.id ? value.id : value.serial);

    if (subTaskForm?.serial === value?.serial && subTaskForm?.task_type === "new") {
      setSubTaskForm(initialSubTaskForm);
    } else if (subTaskForm?.id === value?.id && subTaskForm?.task_type !== "new") {
      setSubTaskForm(initialSubTaskForm);
    } else {
      setSubTaskForm(value);
    }
  };

  const handleDeleteSubTask = (value) => {
    handleDeleteSubtask([value?.id ?? value?.serial], "sub_tasks", value?.serial);
  };

  const HeaderAction = () => {
    return (
      <button
        className="bg-[#2999BC] text-[#FFFFFF] px-3 py-1 rounded-md text-base"
        onClick={() => {
          formData?.category_id?.toLowerCase() === "task" ? addSubtask() : addChecklist();
          setEditingSubTaskId(null);
        }}
      >
        Save
      </button>
    );
  };

  const handleToggleTaskComplete = (index) => {
    // console.log(formData, "hellooeee");

    const updatedTasks = [...formData.sub_tasks];
    const currentTask = updatedTasks[index];

    // If marking as Completed
    if (currentTask.status !== "Completed") {
      updatedTasks[index] = {
        ...currentTask,
        previous_status: currentTask.status, // save original status
        previous_status_color_code: currentTask.status_color_code,
        status: "Completed",
        status_color_code: "#37BE20",
      };
    } else {
      // If unchecking, revert to previous_status
      updatedTasks[index] = {
        ...currentTask,
        status: currentTask.previous_status || "Pending",
        status_color_code: currentTask.previous_status_color_code,
        previous_status: undefined, // clear the temporary storage
        previous_status_color_code: undefined,
      };
    }

    setFormData((prev) => ({
      ...prev,
      sub_tasks: updatedTasks,
    }));
  };

  useEffect(() => {
    fetchPersonData("");
  }, []);

  const handleSelectChange = (e, index) => {
    if (!e.target.value) return;

    // console.log(e, "helloselected");
    const { value, name } = e.target;
    handleChangeSearch(e);

    const selectedValue = personTableData?.find((item) => item.id === value[0]);

    handleSubtaskChange(index, {
      target: { value: selectedValue, name: name },
    });
  };

  return (
    <CustomDrawer
      subDrawer={subDrawer}
      open={open}
      headerText="Edit Sub Task"
      headerAction={HeaderAction()}
      onClose={onClose}
    >
      <div className="w-full h-full min-h-0 grow flex flex-col overflow-y-auto justify-center">
        <div
          //   ref={subTaskContainerRef}
          className={`overflow-x-auto overflow-y-auto flex flex-col gap-y-6 w-full  ${formData?.sub_tasks?.length >= 1 && "min-h-[220px]"} thinscrollbar `}
        >
          {[subTaskForm]?.map((subtask, index) => (
            <div className="flex gap-1 pt-2 pb-4 px-[6px] bg-[#FFF] rounded-md border border-[#BECBD3] " key={index}>
              {/* {isEditTask && (
              <Checkbox
                checked={
                  subtask.status === "Completed" || subtask?.status === "Drop" || subtask?.status === "Cancelled"
                }
                onChange={(e) => handleSubtaskCheckboxChange(subtask, e.target.checked, index)}
                icon={<i className="bi bi-square text-434852"></i>}
                checkedIcon={
                  subtask?.status === "Completed" ? (
                    <i className="bi bi-check-square-fill text-green-500"></i>
                  ) : subtask?.status === "Drop" || subtask?.status === "Cancelled" ? (
                    <i className="bi bi-check-square-fill text-red-500"></i>
                  ) : (
                    <i className="bi bi-square text-434852"></i>
                  )
                }
                className="h-[28px]"
                disabled={isFormDisabled}
              />
            )} */}

              {/* {!isEditTask && (
              <Checkbox
                checked={Boolean(subTaskSelected[index])}
                value={subtask}
                onChange={(e) => handleNewSubtaskCheckboxChange(subtask, e.target.checked, index)}
                icon={<i className="bi bi-square text-434852"></i>}
                checkedIcon={<i className="bi bi-check-square-fill text-red-500"></i>}
                className="h-[28px]"

                // {...label}
                // inputProps={{ 'aria-label': 'controlled' }}
              />
              // <input
              //   type="checkbox"
              //   checked={subTaskSelected[index]}
              //   onChange={(e) => handleNewSubtaskCheckboxChange(subtask, e.target.checked, index)}
              // />
            )} */}

              <div key={index} className={`grid grid-cols-2 gap-x-2 gap-y-1 group relative w-full px-3`}>
                <div className="col-span-2">
                  {/* <label htmlFor={`subtask-subject-${index}`} className="inline-block mb-1 text-lg text-434852"
                  >
                  <p className="text-sm font-medium text-434852">
                    Subject<span className="text-red-700"> *</span>
                  </p>
                </label> */}
                  <LabelComponent htmlFor={`subtask-subject-${index}`} labelText="Subject" isMandatory />

                  <InputComponent
                    type="text"
                    id={`subtask-subject-${index}`}
                    name="subject"
                    placeholder="Enter Subject"
                    value={subtask?.subject || ""}
                    onChange={(e) => handleSubtaskChange(index, e)}
                    height="28px"
                    disabled={isFormDisabled}
                  />

                  {/* <span
                                        className={`text-red-700 
                                        ${
                                          errors?.sub_tasks?.subject[index]?.value === index ? "" : "invisible"
                                        }
                                        `}
                                      > */}
                  {/* <span className={`text-red-700`}>*</span> */}
                </div>

                <div className="col-span-2">
                  {/* <label htmlFor={`subtask-start-date-${index}`} className="block text-lg text-434852">
                    <span className="text-sm font-medium text-434852">Due Date</span>
                  </label> */}
                  <LabelComponent htmlFor={`subtask-start-date-${index}`} labelText="Due Date" />
                  {/* <input
                                                  type="date"
                                                  id={`subtask-start-date-${index}`}
                                                  name="start_date"
                                                  value={subtask?.start_date}
                                                  min={startDate.toISOString().split('T')[0]}
                                                  max={endDate.toISOString().split('T')[0]}
                                                  onChange={(e) => handleSubtaskChange(index, e)}
                                                  className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-xs block w-full "
                                                /> */}
                  <div className="flex">
                    <div className="relative">
                      <DatePicker
                        ref={datePickerRef}
                        selected={new Date(subtask?.start_date)}
                        popperContainer={({ children }) =>
                          createPortal(children, document.getElementById("portal-root"))
                        }
                        onChange={(date) => {
                          handleSubtaskChange(index, {
                            target: { name: "start_date", value: date.toISOString() },
                          });
                          handleSubtaskChange(index, {
                            target: { name: "end_date", value: date.toISOString() },
                          });
                        }}
                        minDate={new Date(startDate)}
                        maxDate={new Date(endDate)}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Start Date"
                        className={` rounded border ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block h-[28px] w-full pl-1`}
                        disabled={isFormDisabled}
                      />

                      <div
                        className="absolute right-0 top-0 cursor-pointer"
                        onClick={() => datePickerRef.current?.setOpen(true)}
                      >
                        <span>
                          <CalendarIcon className="h-[28px] w-[29px]" />
                        </span>
                      </div>
                    </div>
                    {/* 
                <div className="relative  w-1/2">
                  <DatePicker
                    selected={new Date(subtask?.end_date)}
                    popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
                    onChange={(date) => {
                      handleSubtaskChange(index, {
                        target: { name: "end_date", value: date },
                      });
                    }}
                    minDate={new Date(subtask?.start_date)}
                    maxDate={new Date(endDate)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="End Date"
                    className={`rounded border ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block ml-1 h-[28px] w-full pl-1`}
                    disabled={isFormDisabled}
                  />

                  <div className="absolute right-0 top-0 pointer-events-none">
                    <span>
                      <CalendarIcon />
                    </span>
                  </div>
                </div> */}
                  </div>
                </div>

                <div className="grid grid-cols-2 rounded-md col-span-2 text-nowrap">
                  <div className="flex items-center">
                    <FormControlLabel
                      control={
                        <Tooltip
                          title="Mark As Calendar"
                          arrow
                          placement="top"
                          PopperProps={{ style: { zIndex: 9999 } }}
                        >
                          <Checkbox
                            key={index}
                            name="show_on_calendar"
                            icon={<DateLight className={"fill-[#969BA9]"} />} //vinay
                            checkedIcon={<DateLight className={" fill-[#2999BC]"} />}
                            checked={subtask?.show_on_calendar || ""}
                            onChange={(e) => handleSubtaskChange(index, e)}
                            disabled={isFormDisabled}
                          />
                        </Tooltip>
                      }
                      sx={{
                        margin: 0,
                        padding: 0,
                        "& .MuiCheckbox-root": {
                          paddingLeft: 0,
                        },
                      }}
                      className="h-[28px]"
                    />
                    <p className="text-sm ">Show on calendar</p>
                  </div>
                  {/* {subtask?.is_deletable ||
                  (!isEditTask && (
                    <div className="flex justify-end items-center">
                      <button
                        type="button"
                        onClick={() => handleDeleteSubTasks(index)}
                        className={` ${isFormDisabled ? "text-868686 bg-[white]" : "text-white bg-red-500"} rounded-md text-md px-5 py-1 opacity-100 group-hover:opacity-100 transition-opacity`}
                        disabled={isFormDisabled}
                      >
                        Delete
                      </button>
                    </div>
                  ))} */}
                </div>

                {/* {console.log(taskassignedtoref.current?.offsetWidth, "taskassignedtoref aakash")} */}
                {/* Assigned to */}
                <div className="col-span-2">
                  <div className="flex w-full">
                    <div className="relative w-full">
                      <div className="flex flex-col">
                        <LabelComponent htmlFor={`subtask-status-${index}`} labelText="Assigned To" isMandatory />
                        {/* <button type="button" ref={taskassignedtoref} disabled={isFormDisabled} className="flex"> */}
                        {/* <AddTaskProfileIcn /> */}
                        {false && (
                          <div ref={taskassignedtoref} className="relative w-full">
                            <div
                              onClick={(event) => {
                                // taskassignedtoref.current = event.target.closest("button");
                                // handleMouseEnter(index);
                                setOpenAssignedTo(!openAssignedTo);
                                if (!openAssignedTo) fetchPersonData("");
                              }}
                              className="w-full relative"
                            >
                              <input
                                type="text"
                                placeholder="Select assignee"
                                className={` rounded border ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block  w-full h-[28px] px-2`}
                                value={subTaskForm?.assigned_to?.[0]?.name || subTaskPersonSearch || ""}
                                onFocus={(event) => {
                                  // taskassignedtoref.current = event.target;
                                  // setOpenAssignedTo(true);
                                  fetchPersonData("");
                                }}
                                onChange={(e) => {
                                  handleChangeSearch(e);
                                  setOpenAssignedTo(true);
                                }}
                                disabled={isFormDisabled}
                              />

                              <div className="absolute right-[1px] top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <UserIconInputBox />
                              </div>
                              {openAssignedTo && (
                                <FloatingList mode={"vertical"} margin={0}>
                                  <div
                                    onMouseLeave={() => setOpenAssignedTo(false)}
                                    className="  mt-2 bg-white rounded-md border shadow-3 pt-3 mb-6 absolute z-[1]"
                                    style={{ width: `${taskassignedtoref.current?.offsetWidth}px` }}
                                  >
                                    <div className="px-4">
                                      <input
                                        type="text"
                                        placeholder="Type a name or email address"
                                        className="w-full h-[28px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-1"
                                        value={subTaskPersonSearch || ""}
                                        onChange={(e) => handleChangeSearch(e)}
                                        onClick={(e) => e.stopPropagation()}
                                      />
                                    </div>

                                    <div className="pb-3 align-center">
                                      <h3 className="text-14 font-500 ml-4 mb-1">Assigned</h3>
                                      <ul className="list-none max-h-[70px] overflow-y-auto">
                                        {subTaskForm?.assigned_to?.map((eachInput, subIndex) => {
                                          const initials = eachInput?.name
                                            ?.split(" ")
                                            ?.filter((word) => word.length > 0)
                                            ?.map((word) => word.charAt(0).toUpperCase())
                                            ?.slice(0, 2)
                                            ?.join("");
                                          return (
                                            <li
                                              key={subIndex}
                                              className="list-none cursor-pointer py-1"
                                              onClick={() =>
                                                handleSubtaskChange(index, {
                                                  target: { value: eachInput, name: "assigned_to" },
                                                })
                                              } // Pass index and person
                                            >
                                              <div className="flex justify-between items-center">
                                                <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                                                  <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                                    {initials}
                                                  </div>
                                                  <p className="mb-1 ">{eachInput?.name}</p>
                                                </div>
                                                <div className="pr-6 mb-1">
                                                  <i class="bi bi-x-circle"></i>
                                                </div>
                                              </div>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </div>
                                    <div>
                                      <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
                                    </div>
                                    <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] h-[70px] overflow-y-auto thinscrollbar">
                                      {personTableData
                                        ?.filter(
                                          (eachInput) =>
                                            eachInput?.name
                                              ?.toLowerCase()
                                              .includes(subTaskPersonSearch?.toLowerCase() || "") &&
                                            !subTaskForm?.assigned_to?.some((eachValue) =>
                                              eachValue?.name?.toLowerCase().includes(eachInput?.name?.toLowerCase())
                                            )
                                        )
                                        .map((eachInput, subIndex) => {
                                          const initials = eachInput?.name
                                            .split(" ")
                                            .filter((word) => word.length > 0)
                                            .map((word) => word.charAt(0).toUpperCase())
                                            .slice(0, 2)
                                            .join("");
                                          return (
                                            <div className="flex space-x-2 cursor-pointer" key={subIndex}>
                                              <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                                {initials}
                                              </div>
                                              <li
                                                onClick={() =>
                                                  handleSubtaskChange(index, {
                                                    target: { value: eachInput, name: "assigned_to" },
                                                  })
                                                }
                                              >
                                                {eachInput?.name}
                                              </li>
                                            </div>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                </FloatingList>
                              )}
                              {/* {subTaskForm?.assigned_to?.length >= 1 ? (
                                <Fragment>
                                  {subTaskForm?.assigned_to
                                    ?.filter((a, index) => index < 1)
                                    .map((eachInput, subIndex) => {
                                      console.log("eachInput", subTaskForm?.assigned_to);
                                      const initials = eachInput?.name

                                        .split(" ")
                                        .filter((word) => word.length > 0)
                                        .map((word) => word.charAt(0).toUpperCase())
                                        .slice(0, 2)
                                        .join("");

                                      const fullName = eachInput?.name;

                                      return (
                                        <Tooltip
                                          title={
                                            <>
                                              <div className="py-2 min-w-[249px]">
                                                <div className="rounded-lg bg-white">
                                                  <div className="border-b-2 space-y-2 pb-2">
                                                    <div className="flex px-2 space-x-2">
                                                      <div>
                                                        <div className=" flex justify-center items-center ">
                                                          <AvatarName
                                                            name={initials}
                                                            size="small"
                                                            bgColor={"#E8ECF299"}
                                                            textColor={"#7C7C83"}
                                                            borderColor={"#ABABAC"}
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="text-2999BC text-14">{fullName}</div>
                                                    </div>

                                                    <div className="flex px-2 space-x-2 my-2">
                                                      <div className="w-5 text-center">
                                                        <EmailIcon />
                                                      </div>
                                                      <div className="text-F16136 text-12">{eachInput?.email}</div>
                                                    </div>

                                                    <div className="flex px-2 space-x-2 my-2">
                                                      <div className="w-5 text-center">
                                                        <PhoneIcon />
                                                      </div>
                                                      <div className="text-F16136 text-12">
                                                        {eachInput?.mobile ? eachInput?.mobile : "Not Avaliable"}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="flex justify-end mt-2 me-5 text-12">
                                                    <button
                                                      className="text-blue-500"
                                                      // onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                                                    >
                                                      Show more
                                                    </button>
                                                  </div>
                                                </div>
                                                <div></div>
                                              </div>
                                            </>
                                          }
                                          PopperProps={{ style: { zIndex: 99999 } }}
                                          placement="top"
                                          arrow
                                          componentsProps={{
                                            tooltip: {
                                              sx: {
                                                bgcolor: "common.white",
                                                filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                                color: "#383838",
                                                "& .MuiTooltip-arrow": {
                                                  color: "common.white",
                                                  filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                                },
                                              },
                                            },
                                          }}
                                        >
                                          <div key={subIndex}>
                                            <AvatarName
                                              name={initials}
                                              size="medium"
                                              bgColor={getColorForName(fullName)}
                                              textColor={"#ffffff"}
                                              borderColor={"#ffffff"}
                                            />
                                          </div>
                                        </Tooltip>
                                      );
                                    })}
                                </Fragment>
                              ) : (
                                <AddProfileWithCircle />
                              )} */}
                            </div>
                          </div>
                        )}

                        <SelectComponent
                          options={personTableData?.map((option) => ({
                            value: option.id,
                            label: option.name,
                            subLabel: option.email,
                          }))}
                          personList
                          // multiSelect
                          onChange={(e) => handleSelectChange(e, index)}
                          name="assigned_to"
                          value={personTableData
                            ?.filter((option) => option.id === subtask?.assigned_to?.[0]?.id)
                            .map((option) => ({
                              value: option.id,
                              label: option.name,
                              subLabel: option.email,
                            }))}
                          size="small"
                        />
                      </div>
                    </div>

                    {/* <div className="pl-1 pt-1 flex items-center">
                                          {subtask?.assigned_to
                                            ?.filter((a, index) => index < 1)
                                            .map((eachInput, subIndex) => {
                                              const initials = eachInput.name
                                                .split(" ")
                                                .filter((word) => word.length > 0)
                                                .map((word) => word.charAt(0).toUpperCase())
                                                .slice(0, 2)
                                                .join("");
                                              return (
                                                <div
                                                  key={subIndex}
                                                  className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300 p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]"
                                                >
                                                  {initials}
                                                </div>
                                              );
                                            })}
                                          {subtask?.assigned_to?.length > 1 && (
                                            <div className="">
                                              <div className="bg-gray-200 text-gray-500 text-[9px] font-600 border-gray-300 p-[3px] w-6 h-6 flex items-center justify-center rounded-full border-[1px]">
                                                + {subtask?.assigned_to?.length - 1}
                                              </div>
                                            </div>
                                          )}
                                        </div> */}
                  </div>
                </div>
                {/* status */}
                <div className=" flex flex-col justify-start w-full col-span-2">
                  <LabelComponent htmlFor={`subtask-status-${index}`} labelText="Status" />

                  <BasicSelect
                    id={`subtask-status-${index}`}
                    name="status"
                    value={subtask.status || ""}
                    onChange={(e) => handleSubtaskChange(index, e)}
                    options={customerTaskCategory?.data?.status.map((item) => ({
                      value: item.value,
                      label: item.value,
                    }))}
                    selectedOptions={customerTaskCategory?.data?.status
                      .filter((item) => item.value === subtask.status)
                      .map((item) => ({
                        value: item.value,
                        label: item.value,
                      }))}
                  />
                </div>

                {/* <FormControlLabel
                                                  control={
                                                                            <Checkbox
                                                                              icon={<i class="bi bi-calendar"></i>}
                                                                              checkedIcon={<i class="bi bi-calendar-check"></i>}
                                                                            />
                                                  }
                                                  label="Show On Calendar"
                                                  sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                      fontSize: '9px',
                                                    },
                                                  }}
                                                /> */}
              </div>
            </div>
          ))}
        </div>

        <div className="py-4 flex">
          <p className="text-[#434852] text-lg font-poppins font-500">
            Sub Task Listing{" "}
            <span className="text-[#F84545]">
              {" "}
              {formData?.sub_tasks?.length ? `(${formData.sub_tasks.length})` : ""}
            </span>
          </p>
        </div>

        <div
          className={`w-full min-h-0 grow flex flex-col ${formData?.sub_tasks?.length ? "items-start justify-start" : "items-center justify-center"}  overflow-x-hidden bg-white rounded-md border border-[#DFE2E5] thinscrollbar`}
        >
          {formData?.sub_tasks?.length ? (
            formData?.sub_tasks?.map((item, index) => {
              const isSelected =
                item?.task_type === "new" ? item?.serial === subTaskForm?.serial : item?.id === subTaskForm?.id;
              const isBeingEdited = item.id === editingSubTaskId || item.serial === editingSubTaskId;
              return (
                <div
                  key={index}
                  className={`w-full flex flex-col justify-between px-4 py-3 border-b hover:bg-[#EBF2F6] group transition-colors duration-150 ${isSelected ? "bg-gray-100" : "bg-white"} ${
                    isBeingEdited ? "bg-gray-200 pointer-events-none opacity-80" : "hover:bg-[#EBF2F6] bg-white"
                  }`}
                >
                  {/* Content Section */}
                  <div className="flex items-start gap-2 w-full">
                    {/* <input type="checkbox" checked readOnly className="accent-[#2581D7] mt-[2px]" /> */}
                    <div onClick={() => handleToggleTaskComplete(index)} className="py-[2px]">
                      <CompletionCheckbox isChecked={item.status?.toLowerCase() === "completed"} size="small" />
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <span className="text-[#1D4469] font-semibold text-base truncate">{item?.subject}</span>

                      <div className="flex items-center gap-2 text-sm pl-[1px] text-[#383838] font-norma ">
                        <ProfileIcon />
                        {item?.assigned_to?.[0]?.name || "Assignee Name"}
                      </div>

                      <div className="flex items-center gap-2 text-[#888888] text-sm ">
                        <DateLight className="fill-[#969BA9]" />
                        {getDDMonthYYYY(item?.start_date)}
                      </div>

                      <div className="flex items-center justify-between gap-2 mt-1">
                        <button
                          className="text-xs px-2 py-[2px] rounded border font-medium"
                          style={{
                            backgroundColor: `${item?.status_color_code || "#2581D7"}1A`,
                            color: item?.status_color_code || "#2581D7",
                            borderColor: item?.status_color_code || "#2581D7",
                          }}
                        >
                          {item?.status || "Status"}
                        </button>

                        {/* <AvatarName
                        name={getInitials(item?.assigned_to?.[0]?.name)}
                        size="medium"
                        bgColor={getColorForName(item?.assigned_to?.[0]?.name)}
                        textColor="ffffff"
                      /> */}

                        {/* Action buttons - bottom right */}
                        <div className="flex justify-end gap-2 invisible group-hover:visible">
                          <CircleEdit className="cursor-pointer" onClick={() => handleEditSubTask(item)} />
                          <CircleDelete className="cursor-pointer" onClick={() => handleDeleteSubTask(item)} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-[#888888] text-base font-400 font-poppins">No Subtask Available!!</p>
          )}
        </div>
      </div>
    </CustomDrawer>
  );
};
